import { useMediaQuery, useTheme } from "@mui/material";


export const useIsTablet = () =>
  useMediaQuery(useTheme().breakpoints.down('md'));
